export const prefix = 'fbt:';
export var FieldNames;
(function (FieldNames) {
    FieldNames["optimizationObjective"] = "fbt:optimizationObjective";
})(FieldNames || (FieldNames = {}));
export var BusinessObjectiveOptions;
(function (BusinessObjectiveOptions) {
    BusinessObjectiveOptions["RevenuePerOrder"] = "revenue-per-order";
})(BusinessObjectiveOptions || (BusinessObjectiveOptions = {}));
export const defaultFormValues = {
    [FieldNames.optimizationObjective]: BusinessObjectiveOptions.RevenuePerOrder,
};
export const labelByFieldOption = {
    [BusinessObjectiveOptions.RevenuePerOrder]: 'RECS_MODEL_STEP_FREQUENTLY_BOUGHT_TOGETHER_REVENUE_PER_SESSION',
};
